module.exports = "<!--The form-->\r\n\r\n<div ng-bind=\"formResponse.form.title\" ng-class=\"{'form-header':formResponse.form.title}\"></div>\r\n\r\n<form-field-response\r\n  ng-repeat=\"field in formResponse.fields track by field.id\"\r\n  ng-if=\"!field.response.legacy\"\r\n  field-api=\"formResponse.fieldApis[field.id]\"\r\n  model=\"field\">\r\n</form-field-response>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/response/response.html
// module id = 3423
// module chunks = 0